import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-save",
  "use": "icon-save-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-save\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M15,18H9V14h6Zm1,0V13H8v5H7a1,1,0,0,1-1-1V7A1,1,0,0,1,7,6h8.33L18,8.67V17a1,1,0,0,1-1,1Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol